// Components
import { FormFull } from "form-full";
import { Grid } from "@material-ui/core";
import { Input, CustomText } from "../../../components/index";

// Hooks
import React from "react";
import { masks, hooks } from "../../../utils";
import { api } from "../../../services";

// Styles
import Styles from "../styles";
import { fonts, Colors } from "../../../config";

// Interfaces
export interface OwnerDataProps {
    id: string;
    email: string;
    name: string;
    cpf: string;
    places: any[]
}

function onSubmit(data: any) {
  console.log(data);
}

function DadosBasicos(ownerData: any) {
    //hooks de requisição
    const { call, loading } = hooks.useRequest();

    return(
        <Styles.ContainerDadosBasicos>
            <CustomText
                fontSize={2} 
                textColor= {Colors.blue}
                fontFamily={fonts.bold}
            >
                Dados Básicos
            </CustomText>
            <Styles.FormContainer>
                <FormFull 
                    onSubmit={(data) => onSubmit(data)}
                    currentValues={ownerData.ownerData}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={8} lg={6}>
                            <Input name="name" label="Nome Completo"/>
                        </Grid>
                        <Grid item xs={12} md={4} lg={3}>
                            <Input name="cpf" label="Cpf" mask={masks.CPF} maskToSubmit={masks.removeNumberMask} />
                        </Grid>
                        <Grid item xs={12} md={4} lg={3}>
                            <Input name="email" label="E-mail" />
                        </Grid>
                    </Grid>
                    <Styles.SubmitContainer>
                        <Styles.Submit
                            //   loading={loading}
                            //   disabled={loading}
                            fullWidth={false}
                            action="submit"
                        >
                            Editar Dados
                        </Styles.Submit>
                    </Styles.SubmitContainer>
                </FormFull>
            </Styles.FormContainer>
        </Styles.ContainerDadosBasicos>
    )
}

export default DadosBasicos;